import { createDirectus, rest, staticToken } from "@directus/sdk";
import type { Schema } from "./directusTypes";
import { getDirectusHost } from "./directusHost";

export const directus = createDirectus<Schema>(getDirectusHost())
  .with(
    rest({
      onRequest: (options) => ({
        ...options,
        cache: "no-store",
      }),
    })
  )
  .with(staticToken(process.env.DIRECTUS_TOKEN || ""));
